import { useEffect, useState } from "react";
import PersonalInfoView from "../../../../Views/Profile/Views/PersonalInfo/PersonalInfoView";
import { useDispatch, useSelector } from "react-redux";
import { updateProfileAction } from "../../../../store/actions/userAction";
function PersonalInfoScreen() {
  const { userInfo } = useSelector((state: any) => state.user);
  const userPersonalInfoFromState  = userInfo && userInfo.personalInfo ? userInfo.personalInfo : {}
  const dispatch: any = useDispatch();
  const [personalInfoEditMode, setPersonalInfoEditMode] = useState(false);
  const [userPersonalInfo, setUserPersonalInfo] :any = useState({});
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  const phoneNumberNonEditable =userInfo?.phoneNumber;
  //const userId =userInfo?.id
        
  useEffect(() => {
    if (userPersonalInfoFromState) {
      setUserPersonalInfo(userPersonalInfoFromState);
    }
  }, [userPersonalInfoFromState]);

  const cancelUpdate = ()=>{
    if (userPersonalInfoFromState) {
      setUserPersonalInfo(userPersonalInfoFromState);
    }
    setPersonalInfoEditMode(false)
  }

  const submitUpdate = ()=>{
    const updatedUserDetailsPayload = {
      firstName:userPersonalInfo.firstName,
      lastName:userPersonalInfo.lastName,
      email:userPersonalInfo.email,
      dateOfBirth:userPersonalInfo.dateOfBirth,
    }
    dispatch(updateProfileAction(updatedUserDetailsPayload))
    setPersonalInfoEditMode(false)
    // UserService.updateUserProfile(updatedUserDetailsPayload,userId)
    // .then((res)=>{
    //   dispatch(fetchUserDetails({ mobileNo: userMobileNumber }))
    //   setPersonalInfoEditMode(false)

    // })
    // .catch((err:any)=>{
    // })
  }
  
  return (
    <div>
      <PersonalInfoView
        userDetails={userInfo}
        userPersonalInfoFromState={userPersonalInfoFromState}
        userPersonalInfo={userPersonalInfo}
        setUserPersonalInfo={setUserPersonalInfo}
        setPersonalInfoEditMode={setPersonalInfoEditMode}
        personalInfoEditMode={personalInfoEditMode}
        phoneNumberNonEditable={phoneNumberNonEditable}
        cancelUpdate={cancelUpdate}
        submitUpdate={submitUpdate}
        datePickerOpen={datePickerOpen}
        setDatePickerOpen={setDatePickerOpen}
      />
    </div>
  );
}

export default PersonalInfoScreen;
